import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/playlist',
    name: 'Playlist',
    component: Home
  },
  {
    path: '/main',
    name: 'Main',
    component: Home
  },
]

const router = new VueRouter({
    mode: 'hash',
    routes
})

export default router
